import * as actionTypes from "./actionTypes";
import { authenticate, getAxiosInstance } from "../util/service";
import { LAUNCH_LOGIN_URL, moduleTypes } from "../util/constants";
import { store } from "../store/configureStore";
import { clearAllCookies } from "../util/cookieHelper";
import { setDataToLaunchStore } from "../util/customMethods";

export const authenticateUser = (userName, password, subDomain) => {
  return async (dispatch) => {
    const resp = await authenticate(userName, password, subDomain);
    if (resp.isAuthenticated) {
      const setval = await dispatch({
        type: actionTypes.SET_AUTH_INFO,
        payload: resp.loginUserResp,
      });
      if (resp.loginUserResp.userDetails.isReset === 1) {
        await dispatch(
          getAccessLevels(
            resp.loginUserResp.userDetails.employeeId,
            resp.loginUserResp.userDetails.companyId,
            resp.loginUserResp.oaAuthTokens.access_token
          )
        );
      }
      return resp;
    } else {
      await dispatch({ type: actionTypes.SET_AUTH_INFO, payload: undefined });
      return false;
    }
  };
};
export const forgetPassword = (emailId, option) => {
  return async (dispatch) => {
    let _url = `/userAuthService/recoverUserPassword`;
    try {
      const response = await getAxiosInstance(moduleTypes.SERVICE).post(_url, {
        emailId: emailId,
        forgetOption: option,
      });
      if (response.data.statusCode === 200) {
        return response.data;
      } else {
        return response.data;
      }
    } catch (error) {
      return { statusCode: null, statusMsg: error.message };
    }
  };
};
export const resetPassword = (
  newPassword,
  forgotToken,
  empEmail,
  userId,
  subDomain
) => {
  return async (dispatch) => {
    let _url = `userAuthService/resetPassword`;
    try {
      const response = await getAxiosInstance(moduleTypes.SERVICE).post(_url, {
        confirmPassword: newPassword,
        newPassword: newPassword,
        pwdForgottoken: forgotToken,
        empEmail: empEmail,
        userId: userId,
        subdomain: subDomain,
      });
      if (response.data.statusCode === 200) {
        return response.data;
      } else {
        return response.data;
      }
    } catch (error) {
      return { statusCode: null, statusMsg: error.message };
    }
  };
};

export const getAccessLevels = (empId, companyId) => {
  return async (dispatch) => {
    try {
      const resp = await getAxiosInstance(moduleTypes.ADMIN).get(
        `employee/select/employeeAccessLevel?empId=${empId}&companyId=${companyId}`
      );
      if (resp.status === 200) {
        dispatch({
          type: actionTypes.SET_ACCESS_LEVELS,
          payload: resp.data.employeeAccess,
        });
        dispatch({
          type: actionTypes.SET_DASHBOARD_ACCESS_LEVELS,
          payload: resp.data.dashboardAccess,
        });
        // Sync to local storage so utility functions (getAccessLevelsByModule, etc.) have data immediately
        setDataToLaunchStore('accessLevel', resp.data.employeeAccess || {});
        setDataToLaunchStore('dashboardAccess', resp.data.dashboardAccess || {});
      } else {
        dispatch({
          type: actionTypes.SET_ACCESS_LEVELS,
          payload: undefined,
        });
        dispatch({
          type: actionTypes.SET_DASHBOARD_ACCESS_LEVELS,
          payload: undefined,
        });
        setDataToLaunchStore('accessLevel', {});
        setDataToLaunchStore('dashboardAccess', {});
      }
    } catch (ex) {
      dispatch({
        type: actionTypes.SET_ACCESS_LEVELS,
        payload: undefined,
      });
      dispatch({
        type: actionTypes.SET_DASHBOARD_ACCESS_LEVELS,
        payload: undefined,
      });
      setDataToLaunchStore('accessLevel', {});
      setDataToLaunchStore('dashboardAccess', {});
    }
  };
};

export const logOutUser = () => {
  return (dispatch) => {
    // Clear Redux state
    dispatch({ type: actionTypes.SET_AUTH_INFO, payload: undefined });
    dispatch({ type: actionTypes.SET_ACCESS_LEVELS, payload: undefined });
    dispatch({
      type: actionTypes.SET_DASHBOARD_ACCESS_LEVELS,
      payload: undefined,
    });

    // Clear all storage
    try {
      localStorage.clear();
      sessionStorage.clear();
      clearAllCookies();
    } catch (error) {
      console.error("Error clearing storage:", error);
    }

    // Redirect to login
    window.location.href = LAUNCH_LOGIN_URL;
  };
};
export const getAccessToken = () => {
  try {
    let _authInfo = store.getState().authInfo;
    if (_authInfo.oaAuthTokens) {
      return _authInfo.oaAuthTokens.access_token || undefined;
    } else {
      return undefined;
    }
  } catch (ex) {
    return undefined;
  }
};
export const setAccessToken = async (resp) => {
  try {
    let _authInfo = store.getState().authInfo;
    let _respObj = _authInfo.oaAuthTokens || {};
    _respObj.access_token = resp.access_token;
    _respObj.refresh_token = resp.refresh_token;
    _respObj.token_creationTime = resp.expires_in;
    _authInfo.oaAuthTokens = _respObj;
    await store.dispatch({
      type: actionTypes.SET_AUTH_INFO,
      payload: _authInfo,
    });
    return true;
  } catch (ex) {
    return false;
  }
};
export const isAuthenticated = () => {
  // Import from authValidator for consistency
  const { isAuthenticated: checkAuth } = require('../util/authValidator');
  return checkAuth();
};
export const isManagementCompany = () => {
  let _authInfo = store.getState().authInfo || {};
  return (_authInfo.userDetails || {}).isManagement || false;
};